import React, { useEffect, useState } from "react";
import useAuth from "@/hooks/useAuth";
import AppLoading from "@/components/AppLoading";

export default function EntraCallback() {
  const auth = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function handleCallback() {
      try {
        const success = await auth.handleEntraCallback();
        if (cancelled) return;

        if (success) {
          const redirectUri = sessionStorage.getItem("redirectUri") || "/";
          window.location.replace(redirectUri);
        } else {
          setError("Login failed. Please try again.");
        }
      } catch (err: any) {
        if (cancelled) return;
        console.error("[EntraCallback] Error:", err);
        setError(err?.message || "Login failed. Please try again.");
      }
    }

    handleCallback();

    return () => {
      cancelled = true;
    };
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
          <img src="/img/velaro.svg" alt="Velaro" className="h-8 mx-auto mb-4" />
          <p className="text-sm text-gray-500 mb-1">Velaro Admin</p>
          <div className="text-red-500 text-xl mb-3">Login Failed</div>
          <p className="text-gray-600 mb-6">{error}</p>
          <button
            onClick={() => {
              sessionStorage.clear();
              window.location.replace("/");
            }}
            className="w-full bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 text-sm font-medium"
          >
            Try Again
          </button>
          <a href="/" className="block mt-3 text-xs text-gray-400 hover:text-gray-600">
            Return to Velaro Admin
          </a>
        </div>
      </div>
    );
  }

  return <AppLoading />;
}
